/*
  useBlobUrl.js
*/

// Npm.
import { useState, useEffect } from 'react';

/**
 * Returns an URL to a blob.
 */
export default function useBlobUrl(blob) {

  const [resultUrl, setResultUrl] = useState('');

  useEffect(() => {
    if (blob) {
      const url = URL.createObjectURL(blob);
      setResultUrl(url);
      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      setResultUrl(null);
    }
  }, [blob]);

  return resultUrl;

}
